/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
} from "@material-ui/core";
import { BsGear } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    borderBottom: theme.box.border,
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    display: "grid",
    padding: "25px",
  },
  dialogWaitingIcon: {
    justifySelf: "center",
    width: "100px",
    height: "100px",
    animation: "$spin 4s linear infinite",
    marginBottom: "15px",
  },
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default ({ title, content, open = false }) => {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <BsGear className={classes.dialogWaitingIcon} />
        {content || "Waiting for Wise Athena servers..."}
      </DialogContent>
    </Dialog>
  );
};
